import { render, staticRenderFns } from "./MinistriesWomens.vue?vue&type=template&id=54d426e0&"
import script from "./MinistriesWomens.vue?vue&type=script&lang=js&"
export * from "./MinistriesWomens.vue?vue&type=script&lang=js&"
import style0 from "./MinistriesWomens.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports